export default "__VITE_ASSET__2Xo0Kj$U__"